import React from 'react';
import { Clock } from 'lucide-react';

export const ServicesStep = ({ services, onSelect }) => (
  <div className="booking-step">
    <h2>Choose a service</h2>
    <div className="service-list">
      {services.map((service) => (
        <div
          key={service.id}
          className="service-card"
          onClick={() => onSelect(service)}
        >
          <div className="service-info">
            <h3>{service.name}</h3>
            <p>{service.description}</p>
          </div>
          <div className="service-meta">
            <span className="duration"><Clock size={14} /> {service.duration_min} min</span>
            <span className="price">£{service.price.toFixed(2)}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);
